import dayjs from "dayjs";

export const calculateDaysBetween = (from, to) => {
  const dateFrom = dayjs(from);
  const dateTo = dayjs(to);

  return dateFrom.diff(dateTo, "day") * -1;
};
